/**
 * Simple nanoid implementation for browser
 * Generates URL-safe unique IDs
 */

const urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

export function nanoid(size = 21): string {
  const bytes = crypto.getRandomValues(new Uint8Array(size));
  let id = "";
  for (let i = 0; i < size; i++) {
    id += urlAlphabet[bytes[i]! & 63];
  }
  return id;
}
